import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const StarPerformers = lazy(() => import("@/pages/agent/quick-links/star-performers/StarPerformers"));
const NewsletterArchives = lazy(() => import("@/pages/agent/quick-links/newsletter-archives/NewsletterArchives"));
const ContactUs = lazy(() => import("@/pages/agent/quick-links/contact-us/ContactUs"));

const Error404 = lazy(() => import("@/pages/Error404"));

const quickLinksRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "star-performers",
    element: <StarPerformers />,
  },
  {
    path: "newsletter-archives",
    element: <NewsletterArchives />,
  },
  {
    path: "contact-us",
    element: <ContactUs />,
  },
];

export default quickLinksRoutes;
